import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AppComponent} from '../app.component';
import {EmailRegex, PhoneFrRegex, maxSimuValidator} from '../const/utils';
import {User} from "../Models/User";
import {OrgMin} from "../Models/OrgMin";

@Component({
	selector: 'app-modal-add-user',
	templateUrl: './modal-add-user.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./modal-add-user.component.less']
})
export class ModalAddUserComponent implements OnInit {
	globalTxt: any;
	modalsTxt: any;
	modalInfo: any;
	submitted = false;
	userForm!: FormGroup;
	user!: User;
	agencies: OrgMin[] = [];
	// agencies: Agency[] = Agency.agencies;
	userId: any = localStorage.getItem('user_id');
	userRole: any = localStorage.getItem('user_role');
	roleModalData: number = 0;
	form_created: boolean = false;
	showMessageIfEmailExist: boolean = false;
	maxSimuTotal: number = 0;

	constructor(
		public app: AppComponent,
		private formBuilder: FormBuilder,
	) {
		const token = JSON.parse(localStorage.getItem("token")!);
		this.maxSimuTotal = token?.simuTotal || 0;
	}

	get f() {
		return this.userForm.controls;
	}

	ngOnInit(): void {

		this.app.dataToolsService.currentModalInfo.subscribe(modalInfo => {
			console.log("modalInfo  => ", modalInfo);
			this.modalInfo = modalInfo;
		});

		this.getInfosInit();
	}

	getInfosInit() {
		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the modal texts
			this.app.dataInitService.getModalTextsForModalComponentOnce(modalsTxt => {
				this.modalsTxt = modalsTxt.addUser;

				let modalData = JSON.parse(localStorage.getItem('modalOpen')!);

				// // If the user is a client, then we add the agent role for the USR_SIMU_TOTAL edition
				// this.modalsTxt.formFields.forEach((field: any) => {
				// 	//modalData?.data?.role == 3 &&
				// 	if (field.param === 'USR_SIMU_TOTAL') {
				// 		if (field.roles && field.roles.length > 0) {
				// 			field.roles.push(2);
				// 			// console.log("field ==> ", field);
				// 			// field.readonly = false;
				// 			// field.readonly = (field.roles.indexOf(this.userRole) == -1);
				// 			// console.log("field ==> ", field);
				// 		}
				// 	}
				// });

				// Get the user data by ID
				if (modalData?.data?.id != -1) {
					// It's an edition: We get the user data by ID
					this.getUserDtoAltById(modalData.data.id);
				} else {
					// It's an addition: We create a new object and add the right role
					this.roleModalData = modalData.data.role;
					console.log("this.user = C'est un ajout ==> ", this.user, this.roleModalData);

					// Call the function to create the form
					this.doUserForm(null);
				}
			});
		});
	}

	getUserDtoAltById(_usrId: number) {
		this.app.apiToolsService.getUserDtoAltById(_usrId).subscribe(
			(user: any) => {
				console.log("res getUserDtoAltById ==> ", user);
				this.user = user;

				// Call the function to create the form
				this.doUserForm(this.user);

			}
		);
	}

	getAllOrganisationsByUsrId(_usrId: number) {
		this.app.apiToolsService.getAllOrganisationsByUsrId(_usrId).subscribe((agencies: any) => {
			console.log("getAllOrganisationsByUsrId ==> ", agencies);
			this.agencies = agencies;

			// Update USR_ORG value
			if (this.agencies.length > 0) {
				let agencyUser = this.agencies.find((agency: any) => agency.ORG_ID == this.user?.USR_ORG?.ORG_ID);
				// Set the value of the form control to the single agency
				if (agencyUser) this.userForm.controls['USR_ORG'].setValue(agencyUser);
			}
		})
	}

	doUserForm(_user: any) {
		const controls: { [key: string]: any[] } = {
			USR_ID: [_user ? _user?.USR_ID : -1],
			USR_NUMERO_EXTERNE: [_user ? _user?.USR_NUMERO_EXTERNE : ''],
			FCT_ID: [_user ? _user?.FCT_ID : this.roleModalData, [Validators.required]],
			USR_PRENOM: [_user ? _user?.USR_PRENOM : '', [Validators.required]],
			USR_NOM: [_user ? _user?.USR_NOM : '', [Validators.required]],
			USR_EMAIL: [_user ? _user?.USR_EMAIL : '', [Validators.required, Validators.pattern(EmailRegex)]],
			USR_TEL_MOBILE: [_user ? _user?.USR_TEL_MOBILE : '', [Validators.required, Validators.pattern(PhoneFrRegex)]],
			USR_SIMU_TOTAL: [_user ? _user?.USR_SIMU_TOTAL : 0, [maxSimuValidator(this.maxSimuTotal)]],
			USR_SIMU_USED: [_user ? _user?.USR_SIMU_USED : 0],
			USR_ID_PARENT: [_user && _user.USR_ID_PARENT ? _user?.USR_ID_PARENT : parseInt(this.userId)],
		};

		if (this.user?.FCT_ID == 2 || this.roleModalData == 2) controls['USR_ORG'] = [_user ? this.user?.USR_ORG : null];

		this.userForm = this.formBuilder.group(controls);
		console.log("this.userForm ==> ", this.userForm);

		if (this.userForm.value.FCT_ID == 2 && this.userForm.value.USR_ID == -1) {
			this.userForm.controls['USR_ORG'].setValue(null);
		}

		// Call the function to get all organisations by user ID
		this.getAllOrganisationsByUsrId(this.userId);

		// Set the form created to true
		this.form_created = true;
	}

	onChangeAgency() {
		//console.log("itemparam ==> ",  this.userForm.value);
	}

	onSubmit() {
		console.log("this.userForm ==> ", this.userForm);
		console.log("this.userForm.value ==> ", this.userForm.value);

		this.showMessageIfEmailExist = false;

		this.submitted = true;

		if (this.userForm.invalid) {
			// ==> Show errorMessage
			console.log("Erreur dans le formulaire userForm");
			return;
		} else {
			console.log("Le formulaire est valide");
			// ==>  Call API to Save or Update the user
			if (this.userForm.value.USR_ID == -1) this.addUserDtoAlt(this.userForm.value);
			else this.updateUserDtoAlt(this.userForm.value);
		}
	}

	addUserDtoAlt(userDto: User) {
		let sendMail = (userDto.FCT_ID == 3) ? 0 : 1;

		this.app.apiToolsService.addUserDtoAlt(userDto, sendMail).subscribe(
			(res: any) => {
				console.log("res addUserDtoAlt ==> ", res);
				this.app.confirmDialogService.confirmThis('', this.modalsTxt.modalSuccessAddUser, "alert", "",
					() => {
						location.reload();
					},
					() => {
					});
			},
			(error: any) => {
				console.error(error.error);
				if (error.status === 409) {
					this.showMessageIfEmailExist = true;
					return;
				}
			});
	}

	updateUserDtoAlt(userDto: User) {
		this.app.apiToolsService.updateUserDtoAlt(userDto).subscribe(
			(res: any) => {
				console.log("res updateUserDtoAlt ==> ", res);

				this.app.confirmDialogService.confirmThis('', this.modalsTxt.modalSuccessEditUser, "alert", "",
					() => {
						location.reload();
					}, () => {
					});
			},
			(error: any) => {
				console.error(error.error);
				if (error.status === 409) {
					this.showMessageIfEmailExist = true;
					return;
				}
			});
	}
}
